import React from "react";
import { useTranslation } from "react-i18next";
import CommonButton from "../Button/CommonButton";
import CommonModal from "./CommonModal";

export default function CommonDeleteConfirmModal({
  showDeleteModal,
  setShowDeleteModal,
  messageToShow = "Some warning...?",
  onConfirm,
}) {
  const { t } = useTranslation();

  return (
    <div>
      <CommonModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        
        modalTitle={t("Confirmation")}
        mainContent={
          <div className="pt-5 pb-[30px] flex justify-center items-center">
            <div>{messageToShow}</div>
          </div>
        }
        primaryActionButton={
          <>
            <CommonButton
              btnLabel={t("Delete")}
              colorType="danger"
              onClick={() => {
                onConfirm();
                setShowDeleteModal(false);
              }}
            />
          </>
        }
        secondaryActionButton={
          <>
            <CommonButton
              btnLabel={t("Cancel")}
              onClick={() => setShowDeleteModal(false)}
            />
          </>
        }
      />
    </div>
  );
}
